import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "d3aad41d-82d4-4902-a0e1-bc448cd1d595",
  publicId: "28",
  name: "Introduction to the Soundscape Approach",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
